// All paths return prefix-free segments (e.g. "invoices", "login").
// For org-scoped navigation: wrap with useMemberPath().path()
// For auth navigation: wrap with toMemberPath() from path.ts
// For route definitions: use directly

// --- Entity paths (org-scoped) ---

export const DASHBOARD_PATH = () => "dashboard";

export const INVOICE_LIST_PATH = () => "invoices";
export const INVOICE_DETAILS_PATH = (code: string) => `invoices/${code}`;

export const RECURRING_INVOICE_LIST_PATH = () => "recurring-invoices";
export const RECURRING_INVOICE_NEW_FORM = () => "recurring-invoices/new";
export const RECURRING_INVOICE_DETAILS_PATH = (code: string) =>
  `recurring-invoices/${code}`;

export const TRANSACTIONS_LIST_PATH = () => "transactions";
export const TRANSACTION_DETAILS_PATH = (code: string) =>
  `transactions/${code}`;

export const SURCHARGE_LIST_PATH = () => "surcharges";
export const SURCHARGE_DETAILS_PATH = (code: string) => `surcharges/${code}`;

export const TAXES_LIST_PATH = () => "taxes";
export const TAXES_DETAILS_PATH = (code: string) => `taxes/${code}`;

export const CLIENT_LIST_PATH = () => "clients";
export const CLIENT_DETAILS_PATH = (code: string) => `clients/${code}`;

export const TIME_ENTRIES_LIST_PATH = () => "time-entries";

export const PROJECT_LIST_PATH = () => "projects";
export const PROJECT_DETAILS_PATH = (code: string) => `projects/${code}`;

export const FORMS_LIST_PATH = () => "forms";
export const FORM_NEW_FORM = () => "forms/new";
export const FORMS_DETAILS_PATH = (code: string) => `forms/${code}`;

// --- Auth paths (org-independent) ---
// NOT org-scoped. For navigation: wrap with toMemberPath() from path.ts

export const LOGIN_PATH = () => "login";
export const SIGNUP_PATH = () => "signup";
export const VERIFY_TWO_FA_PATH = () => "verify-two-fa";
export const REQUEST_PASSWORD_RESET_PATH = () => "request-password-reset";
export const PASSWORD_RESET_PATH = () => "password-reset";
export const VERIFY_YOUR_EMAIL = () => "verify-your-email";
export const EMAIL_VERIFICATION_PATH = () => "verify-email";
export const SOCIAL_CALLBACK_PATH = () => "social-callback";
export const INVITATION_DECISION_PATH = () => "invitation";
